import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Home from './pages/Home';
import { Profile, LessonPage, CoursesPage, BookmarksPage } from './pages';
import { DataProvider } from './DataContext';
import { MainLayout, CleanLayout } from './layouts';
import '@client/i18n/config';

const App = () => {
    const baseUrl = import.meta.env.CLIENT_BASE_URL ?? '/app';
    const [env, setEnv] = useState<string | undefined>(undefined);

    useEffect(() => {
        setEnv(import.meta.env.CONFIG_NAME ?? '');
    }, []);

    return (
        <Router basename={baseUrl}>
            <Routes>
                {/* Rutas públicas */}
                <Route path={`/cursos`} element={<CoursesPage />} />
                <Route path={`/marcadores`} element={<BookmarksPage />} />
                <Route path={`/cursos/:course`} element={<LessonPage />} />

                {/* Rutas protegidas 'CleanLayout' bajo DataProvider */}
                <Route
                    element={
                        <DataProvider>
                            <CleanLayout>
                                <Outlet />
                            </CleanLayout>
                        </DataProvider>
                    }
                >
                    <Route path={`/profile`} element={<Profile name="David" age={25} />} />
                </Route>
                {/* Rutas protegidas 'MainLayout' bajo DataProvider */}
                <Route
                    element={
                        <DataProvider>
                            <MainLayout>
                                <Outlet />
                            </MainLayout>
                        </DataProvider>
                    }
                >
                    <Route path={`/`} element={<Home />} />
                    {/* <Route path={`/about`} element={<About />} /> */}
                </Route>
            </Routes>
        </Router>
    );
};

export default App;
